<template>
  <div id="services-list">
    <ul>
      <li
        v-for="serv in servicesList"
        :key="serv.id"
      >
        {{ serv.content | uppercase }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ServicesList',
  props: {
    servicesList: Array,
  },
  filters: { uppercase: value => value.toUpperCase() },
};
</script>

<style scoped lang="scss">
  #services-list {
    position: relative;

    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    text-align: left;
    color: white;
    font-family: Quicksand, sans-serif;
    font-weight: bold;

    ul { list-style-type: none; padding: 0; margin: 0 }

    li {
      margin: 0.5em auto;

      &::before {
        font-family: fontello, sans-serif;
        font-weight: normal;
        content: '\e800';
      }
    }

    @media (min-width: 768px) {
      ul {
        width: 90%;
        display: grid; grid-gap: 5px;
        grid-template-columns: 1fr 1fr;
        font-size: 1.2em;

        li { margin: 0.5em; }
      }
    }

    @media (min-width: 992px) {
      padding: 25px 150px;
      ul { font-size: 1.4em }
    }

    @media (min-width: 1200px) {
      $width: 1200px;

      width: $width;
      left: calc(50% - calc(#{$width} / 2));
      padding: 50px 25px;
    }
  }
</style>
